import { render } from "./RadioGroup.vue?vue&type=template&id=13d32e94"
import script from "./RadioGroup.vue?vue&type=script&lang=js"
export * from "./RadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp320\\www\\vicra-lara\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Form/RadioGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13d32e94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13d32e94', __exports__)) {
    console.log('reload')
    api.reload('13d32e94', __exports__)
  }
  
  module.hot.accept("./RadioGroup.vue?vue&type=template&id=13d32e94", () => {
    console.log('re-render')
    api.rerender('13d32e94', render)
  })

}


export default __exports__